import React, {useContext} from "react";
import styles from './ProjectMainStats.module.scss';
import {DetailedProjectContext} from "../DetailedProjectContext/DetailedProjectContext";
import {Money} from "../../../common";
import {formatPercents} from "../../../../formatters";
import moment from "moment";
import {declOfNum} from "../../../../utils";
import {useProfileData} from "../../../../hooks";
import {
  isFundRaising,
  ProjectType,
  Role,
  translatePaymentScheduleType,
  translatePrincipalRepaymentType
} from "../../../../api-client";

const ProjectMainStats = () => {
  const project = useContext(DetailedProjectContext).project;
  const {role} = useProfileData();

  const daysUntil = (date?: Date | string): string => {
    if (!date) return '—';
    const daysDiff = moment(date).diff(new Date(), 'days');
    if (daysDiff < 0) return '0 дней';
    return `${daysDiff} ${declOfNum(daysDiff, ['день', 'дня', 'дней'])}`;
  };

  const isFundraising = isFundRaising(project.status);

  return (<>
    <div className={styles.detailedProjectMain}>
      <div className={styles.detailedProjectMain__stats}>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            Сумма сбора
          </div>
          <div className={styles.detailedProjectStat__value}>
            <Money money={project.accounting.loan} />
          </div>
        </div>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            Срок займа
          </div>
          <div className={styles.detailedProjectStat__value}>
            {project.accounting.initialTerm} мес.
          </div>
        </div>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            Ставка договора
          </div>
          <div className={styles.detailedProjectStat__value}>
            {formatPercents(project.accounting.interestRate, 0)}
          </div>
        </div>
        {
          (role === Role.LENDER) && <div className={styles.detailedProjectStat}>
            <div className={styles.detailedProjectStat__type}>
              {project.type === ProjectType.PROJECT ? 'Прогноз доходности' : 'Эффективная ставка'}
            </div>
            <div className={styles.detailedProjectStat__value}>
              {formatPercents(project.accounting.effectiveInterestRate, 0)}
            </div>
          </div>
        }
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            LTV
          </div>
          <div className={styles.detailedProjectStat__value}>
            {formatPercents(project.accounting.ltv)}
          </div>
        </div>
      </div>
      <div className={styles.detailedProjectMain__stats}>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            погашение основного долга
          </div>
          <div className={styles.detailedProjectStat__value}>
            {project.principalRepaymentType
              ? translatePrincipalRepaymentType(project.principalRepaymentType)
              : '—'}
          </div>
        </div>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            погашение процентов
          </div>
          <div className={styles.detailedProjectStat__value}>
            {project.scheduleType
              ? translatePaymentScheduleType(project.scheduleType)
              : '—'}
          </div>
        </div>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            назначение
          </div>
          <div className={styles.detailedProjectStat__value}>
            {project.accounting.purpose}
          </div>
        </div>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            тип обеспечения
          </div>
          <div className={styles.detailedProjectStat__value}>
            {project.accounting.pledgeType}
          </div>
        </div>
        <div className={styles.detailedProjectStat}>
          <div className={styles.detailedProjectStat__type}>
            {isFundraising
              ? 'Сбор до'
              : 'осталось до погашения'}
          </div>
          <div className={styles.detailedProjectStat__value}>
            {isFundraising
              ? daysUntil(project.maturityDate)
              : daysUntil(project.accounting.projectEndDate)}
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default ProjectMainStats;